module.exports = __webpack_public_path__ + "img/D.8b0e14e4.png";